import React from 'react';
import { Field } from 'redux-form';
import Loader from '../../../../common/components/Loader/Loader';
import TextArea from '../../../content/components/TextArea/TextArea';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import { FormGroupInput } from '../../../../common/form/components/components';
import { PublicCheckbox } from '../../../../common/components';
import HorizontalFormControl
  from '../../../../common/components/HorizontalFormControl/HorizontalFormControl';
import InfoButton from '../../../../common/components/InfoButton/InfoButton';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';

const ContactUsSections = () => (
  <>
    <FormGroup>
      <Col sm={6}>
        <ControlLabel>Top Left Section</ControlLabel>
        <Field
          name={'meta.contact_us.content.attributes.sections.top_left_section'}
          component={TextArea}
          minHeight={'400px'}
        />
      </Col>
      <Col sm={6}>
        <ControlLabel>Top Right Section</ControlLabel>
        <Field
          name={'meta.contact_us.content.attributes.sections.top_right_section'}
          component={TextArea}
          minHeight={'400px'}
        />
      </Col>
    </FormGroup>
    <FormGroup>
      <Col sm={12}>
        <ControlLabel>Middle Section</ControlLabel>
        <Field
          name={'meta.contact_us.content.attributes.sections.middle_section'}
          component={TextArea}
        />
      </Col>
    </FormGroup>
    <FormGroup>
      <Col sm={6}>
        <ControlLabel>Address</ControlLabel>
        <Field
          name={'meta.contact_us.content.attributes.sections.address'}
          component={TextArea}
        />
      </Col>
    </FormGroup>
    <FormGroup>
      <Col sm={12}>
        <ControlLabel>Bottom Section</ControlLabel>
        <Field
          name={'meta.contact_us.content.attributes.sections.bottom_section'}
          component={TextArea}
        />
      </Col>
    </FormGroup>

    <Field
      name={'meta.contact_us.content.attributes.sections.meta_title'}
      label={'Meta Title'}
      component={FormGroupInput}
      labelSize={2}
      colSize={12}
    />

    <Field
      name={'meta.contact_us.content.attributes.sections.meta_description'}
      component={FormGroupInput}
      label={'Meta Description'}
      labelSize={2}
      colSize={12}
    />
  </>
);

const ContactUs = ({ template, enabled }) => {


  return (
    <WhiteLabelContentContainer title={'Contact Us content'}>
      <>
        <Row>
          <Col sm={12}>
            <Field
              name={'meta.contact_us.enabled'}
              component={PublicCheckbox}
              label={'Enabled'}
            />
          </Col>
        </Row>
        {!enabled && (
          <Field
            name={'meta.contact_us.alternative_contact_us_url'}
            component={HorizontalFormControl}
            label={"Alternative 'Contact Us' Url"}
            infoButton={<InfoButton content={'Use full url, including http://'}/>}
            labelSize={3}
            fieldSize={5}
          />
        )}
        <div className={`wl-content-box-content ${!enabled ? ' disabled' : ''}`}>
          {template ? (
            <Field
              name={'meta.contact_us.content.attributes.sections'}
              template={template.data}
              component={ContactUsSections}
            />
          ) : (
            <Loader/>
          )}
        </div>
      </>
    </WhiteLabelContentContainer>
  )
    ;
};

export default ContactUs;
